import React from "react";
import { Box, Typography, Button } from "@mui/material";
import StadiumIcon from "@mui/icons-material/Stadium";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import HomeSection from "./HomeSection";
import { homeCardHover } from "./homeStyles";
import { brandOutlinedButtonSx } from "../../utils/brandAssets";

const MyLineupEntry = () => {
  const navigate = useNavigate();

  return (
    <HomeSection
      title="Your lineup"
      subtitle="Name your all-time nine, then share the page."
    >
      <Box
        onClick={() => navigate("/app/lineup")}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          ...homeCardHover,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(34, 197, 94, 0.15)",
            }}
          >
            <StadiumIcon sx={{ color: "#22c55e", fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="body1" fontWeight={600}>
              Build your all-time lineup
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Pick nine plus a DH from the full database, add favorites, and
              publish a public page at your handle.
            </Typography>
          </Box>
        </Box>
        <Button
          variant="outlined"
          endIcon={<ArrowForwardIcon />}
          onClick={(event) => {
            event.stopPropagation();
            navigate("/app/lineup");
          }}
          sx={{
            flexShrink: 0,
            display: { xs: "none", sm: "inline-flex" },
            ...brandOutlinedButtonSx,
          }}
        >
          Start picking
        </Button>
      </Box>
    </HomeSection>
  );
};

export default MyLineupEntry;
